import { BlastEvent, SimulationConfig } from '../../../types';
import { getRadiusAtAngle } from '../../../break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const RadialSliceAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  const slices = 16;
  const t = progress * 500;
  for (let i = 0; i < slices; i++) {
    const mid = (i / slices) * Math.PI * 2;
    const sx = e.pos.x + Math.cos(mid) * t;
    const sy = e.pos.y + Math.sin(mid) * t;
    const rBase = e.maxRadius;
    const r = getRadiusAtAngle(mid, e, rBase);
    ctx.save(); ctx.translate(sx, sy); 
    ctx.beginPath(); ctx.moveTo(0,0); 
    ctx.lineTo(Math.cos(mid)*r*0.2, Math.sin(mid)*r*0.2); 
    ctx.lineWidth = 12 * (1 - progress); ctx.stroke();
    ctx.restore();
  }
};

registerBlastAnimation('RADIAL_SLICE', RadialSliceAnimation);
